import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class ApiError {
  constructor() {}
  toErrorCode(errorResponse: HttpErrorResponse): string {
    return typeof errorResponse.error === "string" ? JSON.parse(errorResponse.error).code : errorResponse.error.code;
  }
  toErrorMessage(errorResponse: HttpErrorResponse): string {
    return typeof errorResponse.error === "string" ? JSON.parse(errorResponse.error).message : errorResponse.error.message;
  }
}
